export function isAdmin(type) {
  if (type === 'admin') {
    return true;
  } else if (type === 'super_admin') {
    return true;
  } else {
    return false;
  }
}
